import { Segmented } from 'antd';
import styled from 'styled-components';

export const StyledSegmented = styled(Segmented)`
  .ant-segmented-item {
    padding: 4px 11px;
  }
  .ant-segmented-item-label {
    padding: 0 !important;
    font-weight: 400;
    line-height: 20px;
  }
`;
